import { Row, Col } from 'antd';
import { BetaSchemaForm } from "@ant-design/pro-components";
import { useEffect, useRef } from 'react';
import { createStyles } from 'antd-style';

export const DualFormLayout = ({columns, values, leftCol, rightCol}) => {
  const leftColumns = columns?.filter(item => leftCol.indexOf(item.dataIndex) != -1);
  const rightColumns = columns?.filter(item => rightCol.indexOf(item.dataIndex) != -1);

  const leftFormRef = useRef();
  const rightFormRef = useRef();

  const useStyles = createStyles(({ token, css }) => ({
    leftFormItem: css`
      .ant-form-item {
        margin-bottom: 2px;
      }
    `,
    rightFormItem: css`
      .ant-form-item {
        margin-bottom: 5px;
      }
    `,
  }));
  const { styles } = useStyles();

  useEffect(()=>{
    if(values && leftCol && rightCol) {
      const leftValues = leftCol.reduce((acc, key) => {
        if (values.hasOwnProperty(key)) {
          acc[key] = values[key];
        }
        return acc;
      }, {});
    
      const rightValues = rightCol.reduce((acc, key) => {
        if (values.hasOwnProperty(key)) {
          acc[key] = values[key];
        }
        return acc;
      }, {});

      if(leftValues)
        leftFormRef.current.setFieldsValue(leftValues);
      if(rightValues)
        rightFormRef.current.setFieldsValue(rightValues);
    }
  }, [values, leftCol, rightCol]);
  return (
    <Row gutter={24} style={{ padding: 24 }}>
      <Col span={8}>
        <div style={{marginBottom: 0}}>
          <BetaSchemaForm
            className={styles.leftFormItem}
            formRef={leftFormRef}
            labelAlign="left"
            layout="horizontal"
            labelCol={{ span: 10 }}
            wrapperCol={{ span: 14 }}
            columns={leftColumns}
            colon={false}
            submitter={false}
          />
        </div>
        
      </Col>
      <Col span={16}>
        <BetaSchemaForm
          className={styles.rightFormItem}
          formRef={rightFormRef}
          labelAlign="left"
          layout="horizontal"
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 20 }}
          columns={rightColumns}
          colon={false}
          submitter={false}
        />
      </Col>
    </Row>
  );
};

export default DualFormLayout;